import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import { ToastCtl } from '../../../../components/custom/toast/ToastCtl'
import { ApiService } from '../../../../../utility/api.service'

export const fetchTenants = createAsyncThunk('tenants/fetchAll', async ({ filter = null, fields = null, offset = 0, limit = 250, sort }) => {
    const query = new URLSearchParams({
        filter: filter ? JSON.stringify(filter) : '',
        fields: fields ? JSON.stringify(fields) : '',
        offset,
        limit,
        sort: sort ? JSON.stringify(sort) : ''
    });

    const response = await ApiService.get(`${process.env.REACT_APP_ASSETENERGY_APP_API}/assetapp/tenants?${query}`)
    return { tenants: Object.values(response.data), count: response.count }
})

export const fetchTenant = createAsyncThunk('tenant/fetch', async ({ id }) => {
    const response = await ApiService.get(`${process.env.REACT_APP_ASSETENERGY_APP_API}/assetapp/user/${id}`)
    return { tenant: response.data.user }
})

export const updateTenant = createAsyncThunk('tenant/update', async ({ id, payload }, { rejectWithValue }) => {
    const response = await ApiService.post(`${process.env.REACT_APP_ASSETENERGY_APP_API}/assetapp/user/${id}`, payload)
    if (!response.success) {
        return rejectWithValue(response.exception)
    }

    return { tenant: response.data.user }
})

const initialState = {
    tenants: [],
    selectedTenant: null,
    loading: false,
    submitting: false,
    error: null,
    count: 0
}

const tenantSlice = createSlice({
    name: 'tenants',
    initialState,
    reducers: {
        // standard reducer logic, with auto-generated action types per reducer
    },
    extraReducers: {
        [fetchTenants.pending]: (state) => {
            state.loading = true
        },
        [fetchTenants.fulfilled]: (state, { payload }) => {
            state.tenants = payload.tenants
            state.count = payload.count
            state.loading = false
        },
        [fetchTenants.rejected]: (state, action) => {
            state.loading = false
            state.error = action
        },

        [fetchTenant.pending]: (state) => {
            state.loading = true
        },
        [fetchTenant.fulfilled]: (state, { payload }) => {
            state.selectedTenant = payload.tenant
            state.loading = false
        },
        [fetchTenant.rejected]: (state, action) => {
            state.loading = false
            state.error = action
        },

        [updateTenant.pending]: (state) => {
            state.submitting = true
        },
        [updateTenant.fulfilled]: (state, { payload }) => {
            state.selectedTenant = payload.tenant
            state.submitting = false

            ToastCtl.success('Daten wurden erfolgreich gespeichert')
        },
        [updateTenant.rejected]: (state, action) => {
            state.submitting = false
            // NO error state because we show toast directly

            ToastCtl.error('Daten konnten nicht gespeichert werden')
        }
    }
})

export default tenantSlice.reducer